import React, { useEffect, useRef, useState } from 'react';

/** Viñeta flotante: muestra cantidad + total. Visible solo cuando la columna está colapsada. */
export function OrderBubble({ count, total, onClick }) {
   return (
      <button type="button" className="sp-ordb" onClick={onClick} aria-label="Ver orden actual">
         <span className="sp-ordb__ic"><i className="uil uil-shopping-cart"></i></span>
         {count > 0 && <span className="sp-ordb__count">{count}</span>}
         <span className="sp-ordb__total" translate="no">${Number(total || 0).toFixed(2)}</span>
      </button>
   );
}

/** Toast que aparece suavemente y se va solo. Dispara SOLO cuando `trigger` AUMENTA
 *  (se agregó algo). Al bajar (quitar/limpiar) no dispara. */
export function OrderAddToast({ trigger, label = "Agregado al carrito" }) {
   const [show, setShow] = useState(false);
   const timer = useRef(null);
   const prev = useRef(trigger);

   useEffect(() => {
      const before = prev.current;
      prev.current = trigger;
      if (trigger > before) {           // solo si AUMENTÓ
         setShow(true);
         if (timer.current) clearTimeout(timer.current);
         timer.current = setTimeout(() => setShow(false), 1600);
      }
      return () => { if (timer.current) clearTimeout(timer.current); };
   }, [trigger]);

   return (
      <div className={`sp-ordtoast ${show ? 'is-show' : ''}`} role="status" aria-live="polite">
         <i className="uil uil-check-circle"></i> {label}
      </div>
   );
}

/** Toast genérico controlado por `open` (para mensajes formales: limpiar, guardar, etc.). */
export function OrderInfoToast({ open, onDone, label = "Listo", type = "info", duration = 2000 }) {
   const timer = useRef(null);
   useEffect(() => {
      if (!open) return;
      if (timer.current) clearTimeout(timer.current);
      timer.current = setTimeout(() => onDone && onDone(), duration);
      return () => { if (timer.current) clearTimeout(timer.current); };
   }, [open, duration, onDone]);

   const icon = type === 'success' ? 'uil-check-circle'
      : type === 'danger' ? 'uil-trash-alt'
      : type === 'warning' ? 'uil-exclamation-triangle' : 'uil-info-circle';

   return (
      <div className={`sp-ordtoast sp-ordtoast--${type} ${open ? 'is-show' : ''}`} role="status" aria-live="polite">
         <i className={`uil ${icon}`}></i> {label}
      </div>
   );
}